"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var constants_1 = require("containers/TableMaker/constants");
var EmailHeadersCell_1 = __importDefault(require("./EmailHeadersCell"));
var XSM = constants_1.CellSize.XSM;
var RemoveBtnCell = function (_a) {
    var onClick = _a.onClick, _b = _a.tooltipTitle, tooltipTitle = _b === void 0 ? 'Delete' : _b, disabled = _a.disabled;
    return ((0, jsx_runtime_1.jsx)(EmailHeadersCell_1.default, __assign({ width: XSM - 4, className: "showOnHover" }, { children: (0, jsx_runtime_1.jsx)(IconButtons_1.RemoveButton, { outlined: true, iconSize: 16, tooltipTitle: tooltipTitle, onClick: function () { return onClick(); }, className: "highlightInput", neutralByDefault: false, disabled: disabled }) })));
};
exports.default = RemoveBtnCell;
